import {
  LOAD_REPORT,
  LOAD_REPORT_FAILED,
  LOAD_REPORT_FINISHED,
  LOAD_REPORT_VERIFICATION,
  LOAD_REPORT_VERIFICATION_FAILED,
  LOAD_REPORT_VERIFICATION_FINISHED
} from 'store/actions/reportAction'
import { LOAD_CONFIGURATION_FAILED, LOAD_CONFIGURATION_FINISHED } from 'store/actions/searchAction'
import { CLOSE_MODAL, SET_REPORT_PREVIEW } from 'store/actions/uiAction'
import { PURGE } from 'redux-persist'

const INITIAL_STATE = {
  error: {
    isError: false,
    msg: null,
    title: null
  },
  isReportLoading: true,
  isReportPreview: false,
  isScreen: { // NOSONAR TODO: Tech debt, refactor this and make 1 loading screen prop for all pages
    loading: true,
    error: false,
    messages: []
  }
}

export default function uiReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case LOAD_REPORT_FINISHED:
    case LOAD_REPORT_VERIFICATION_FINISHED:
      return { ...state, isReportLoading: false }
    case LOAD_REPORT_FAILED:
    case LOAD_REPORT_VERIFICATION_FAILED: {
      let msg
      try {
        msg = action.payload.msg.reduce((acc, val) => [...acc, val.msg], [])
      } catch (e) {
      }

      return {
        ...state,
        isReportLoading: false,
        error: {
          isError: true,
          msg,
          title: action.payload.name
        }
      }
    }
    case CLOSE_MODAL:
    case LOAD_REPORT:
    case LOAD_REPORT_VERIFICATION:
      return { ...state, error: INITIAL_STATE.error }
    case SET_REPORT_PREVIEW:
      return { ...state, isReportPreview: action.payload }
    case LOAD_CONFIGURATION_FINISHED:
      return { ...state, isScreen: { ...state.isScreen, loading: false } }
    case LOAD_CONFIGURATION_FAILED:
      return { ...state, isScreen: { ...state.isScreen, error: true, messages: action.payload } }
    case PURGE:
      return INITIAL_STATE
    default:
      return state
  }
}
